<div class="complete-profile-title">Verify Phone</div>
<p>To keep our community real and safe, please verify your phone number. This helps us reduce fake profiles and ensure you’re connecting with genuine
  people.</p>
<label class="mt-8 block font-bold mb-2">Enter Whatsapp Phone Number</label>
<div class="flex gap-4">
  <div>
    <input [(ngModel)]="countryCode" placeholder="" [readOnly]="showMessage()" type="text" class="w-[90px] shrink-0 border read-only:bg-gray-100 font-bold text-xl rounded-xl px-4 py-4 border-gray-300  hover:outline-0 hover:border-primary">
    <small class="block">Country Code</small>
  </div>
  <div>
    <input [(ngModel)]="phone" [readOnly]="showMessage()" type="text" class="grow border read-only:bg-gray-100 font-bold text-xl rounded-xl px-4 py-4 border-gray-300   hover:outline-0 hover:border-primary">
    <small class="block">Phone Number</small>
  </div>
</div>
@if (otpSent()) {
  <div class="mt-4">
    <label for="" class="block">Enter OTP</label>
    <input [(ngModel)]="otp" required type="text" class="w-full grow border read-only:bg-gray-100 font-bold text-xl rounded-xl px-4 py-4 border-gray-300   hover:outline-0 hover:border-primary">
  </div>
}
@if (numberUsed()) {
  <div class="p-4 bg-red-100 rounded-xl mt-4 flex gap-4 items-center text-sm">
    <i class="fa fa-times-circle text-red-500"></i> This phone number is already associated with another account. Please use a different number.
  </div>
  <button class="btn-base w-full bg-primary text-white mt-6" (click)="changeNumber()">Change Phone Number</button>

} @else if (showMessage()) {
  <button [disabled]="otpSent() && !otp()" (click)="sendOtp()" class="disabled:bg-primary/50 hover:bg-primary/90  cursor-pointer py-4 bg-primary w-full rounded-lg mt-4 text-white text-center">{{ otpSent() ? 'Verify Phone' : 'Send OTP' }}</button>
  <!--  <div class="info-box py-4">-->
    <!--    Please give a miss call on <a href="tel:7710253000" class="font-bold text-lg">77102-53000</a> to verify your number. This form will update automatically-->
    <!--    after-->
    <!--    your-->
    <!--    phone-->
    <!--    verification.-->
    <!--  </div>-->
    <!--  <div class="center-all bg-green-50 py-3 rounded-xl gap-4 text-green-800  text-sm">-->
    <!--    <i class="fa fa-spinner animate-spin"></i> Awaiting verification-->
    <!--  </div>-->
  <button class="btn-base w-full text-primary hover:bg-primary/10 mt-6" (click)="changeNumber()">Change Phone Number</button>
}
